import React, { useState } from "react";
import { CardListProps } from "./interface";
import DeleteIcon from "../../components/deleteIcon";
import { withRouter } from "react-router-dom";
import EmptyPage from "../emptyPage/component";
import moment from "moment";

import RecordLocation from "../../utils/readUtils/recordLocation";
import BookUtil from "../../utils/fileUtils/bookUtil";
import toast from "react-hot-toast";
import BookModel from "../../models/Book";
import axios from "axios";
import api from "../../utils/axios";
import { fetchMD5 } from "../../utils/fileUtils/md5Util";
import StorageUtil from "../../utils/serviceUtils/storageUtil";
import RecordRecent from "../../utils/readUtils/recordRecent";


const CardList: React.FC<CardListProps> = (props) => {
  const [deleteKey, setDeleteKey] = useState<string>("");

  const handleShowDelete = (key: string) => {
    setDeleteKey(key);
  };

  let { cards, mode } = props;
  if (cards.length === 0) {
    return <EmptyPage mode={mode} isCollapsed={props.isCollapsed} />;
  }

  const handleJump = async (note: any) => {
    let bookData: any = await api.get(`/api/ebooks/${note.book_id}`).then((res) => res.data.data);
    const existingBooks = (await window.localforage.getItem<BookModel[]>("books")) || [];
    let book: BookModel | null = existingBooks.find((b) => b.file_key === bookData.file_key) ?? null;

    if (!book) {
      // Book not in localforage: fetch content then add
      let sourceUrl = bookData.url.replace(/_/g, "+");

      const response = await axios.get<ArrayBuffer>(sourceUrl, { responseType: "arraybuffer" });
      const arrayBuffer = response.data;
      const blob = new Blob([new Uint8Array(arrayBuffer)], { type: "application/pdf" });
      const file = new File([blob], bookData.title, { type: "application/pdf" });

      const md5 = await fetchMD5(file);
      if (!md5) {
        throw new Error("Failed to calculate MD5");
      }

      const key = moment(bookData.upload_time).unix().toString();
      const result = await BookUtil.generateBook(
        bookData.title,
        "pdf",
        md5,
        file.size,
        "",
        arrayBuffer,
        bookData.file_key,
        bookData.thumbnail,
        bookData.thumb_url,
        sourceUrl,
        key
      );

      if (result === "get_metadata_error") {
        throw new Error("Failed to get book metadata");
      }

      if (StorageUtil.getReaderConfig("isImportPath") !== "yes") {
        await BookUtil.addBook(key, arrayBuffer);
      }

      const bookModel = result as BookModel;
      bookModel.key = key;
      RecordRecent.setRecent(bookModel.key);

      const updatedBooks = [...existingBooks];
      const bookIndex = updatedBooks.findIndex((b) => b.file_key === bookData.file_key);
      if (bookIndex !== -1) {
        updatedBooks[bookIndex] = bookModel;
      } else {
        updatedBooks.push(bookModel);
      }
      await window.localforage.setItem("books", updatedBooks);
      book = bookModel;
    } else {
      RecordRecent.setRecent(book.key);
    }

    if (!book) {
      toast(props.t("Book not exist"));
      return;
    }

    if (book.format === "PDF") {
      let bookLocation = JSON.parse(note.cfi) || {};
      RecordLocation.recordPDFLocation(book.md5.split("-")[0], bookLocation);
    } else {
      let bookLocation: any = {};
      //compatile wiht lower version(1.4.2)
      try {
        bookLocation = JSON.parse(note.cfi) || {};
      } catch (error) {
        bookLocation.cfi = note.cfi;
        bookLocation.chapterTitle = note.chapter;
      }
      RecordLocation.recordHtmlLocation(
        note.bookKey,
        bookLocation.text,
        bookLocation.chapterTitle,
        bookLocation.chapterDocIndex,
        bookLocation.chapterHref,
        bookLocation.count,
        bookLocation.percentage,
        bookLocation.cfi,
        bookLocation.page
      );
    }

    BookUtil.RedirectBook(book, props.t, props.history);
  };

  const renderCardListItem = (card: any) => {
    return (
      <li
        className="float-left h-[250px] border-[15px] border-transparent relative"
        onMouseOver={() => {
          handleShowDelete(card.id);
        }}
        onMouseLeave={() => {
          handleShowDelete("");
        }}
        style={
          mode === "note" && !props.isCollapsed
            ? { height: "250px" }
            : mode === "note" && props.isCollapsed
            ? { height: "250px", width: "calc(50vw - 70px)" }
            : props.isCollapsed
            ? { width: "calc(50vw - 70px)" }
            : {}
        }
      >
        <div className="h-full rounded-lg p-2.5 shadow-md bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200">
          <div className="relative -bottom-6">
            {deleteKey === card.id ? <DeleteIcon {...card} /> : null}
          </div>
          <div className="flex flex-col mb-2.5">
            <div className="text-xs mb-1.5" style={{ color: '#888' }}>
              {moment(`${card.date.year}-${card.date.month}-${card.date.day}`).format("DD MMMM YYYY")}
            </div>
            <div
             className="flex items-center font-bold text-base cursor-pointer"
        onClick={() => handleJump(card)}
        >
              <span className="w-2 h-2 rounded-full mr-2" style={{ backgroundColor: '#ff9800' }}></span>
              <span>{card.book.title}</span>
            </div>
          </div>
          <div className={`relative w-full mb-2.5 ${mode === "note" ? "h-16" : "h-28"}`}>
            <div className="w-full h-full overflow-auto mx-2.5 relative cursor-text text-sm pr-1 ">
              {mode === "note" ? card.notes : card.text}
            </div>
          </div>
            {mode === "note" ? (
              <div className="relative w-full h-16 opacity-100">
                <div className="w-[calc(100%-20px)] h-full overflow-auto mx-2.5 my-0 relative cursor-text leading-[1.5] text-sm pr-1">{card.text}</div>
              </div>
            ) : null}
        </div>
      </li>
    );
  };

  return (
    <div className="w-full overflow-auto content-start select-text h-full grid 2xl:grid-cols-5 xl:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-2">
      {cards.map((card) => renderCardListItem(card))}
    </div>
  );
};

export default withRouter(CardList as any);
